const accordionCompetitive = () => {
  document.querySelectorAll('.gg-competitive-comparison').forEach((module) => {
    const accordions = module.querySelectorAll('.gg-block-accordion-competitive__group-heading');
    const swiperWrapper = module.querySelector('.wp-block-statik-tabs__inner-blocks');
    const swiperSlides = swiperWrapper ? swiperWrapper.querySelectorAll('.wp-block-statik-tab') : [];
    const clsBlockAccordionCompetitive = '.gg-block-accordion-competitive';
    const clsGroupContent = '.gg-block-accordion-competitive__group-content';
    const clsHeadingFirstChild = '.gg-block-accordion-competitive__group-heading td:first-child';
    const clsActiveExpand = 'active-expand';
    const clsActiveClick = 'active-click';
    const dataIndex = 'data-index';
    let oldIndex;

    const resetAccordionItem = (item) => {
      const itemContent = item.querySelector(clsGroupContent);
      const itemHeading = item.querySelector(clsHeadingFirstChild);
      console.log(item)
      itemContent.classList.remove(clsActiveExpand);
      itemContent.style.maxHeight = null;
      itemHeading.classList.remove(clsActiveClick);
    };

    const toggleAccordion = (accordion, item) => {
      const parent = accordion.closest(clsBlockAccordionCompetitive);
      const index = parent.getAttribute(dataIndex);

      module.querySelectorAll(`.gg-block-accordion-competitive[data-index="${index}"]`).forEach((item) => {
        const itemContent = item.querySelector(clsGroupContent);
        const itemHeading = item.querySelector(clsHeadingFirstChild);

        let heightScreen = 0;

        if (window.innerWidth < 1024 && itemContent.scrollHeight > 0) {
          heightScreen = 32;
        }
        if (itemContent.classList.contains(clsActiveExpand)) {
          resetAccordionItem(item);
          oldIndex = index;
        } else {
          if (index !== oldIndex) {
            module.querySelectorAll(clsBlockAccordionCompetitive).forEach(resetAccordionItem);
            oldIndex = index;
          }

          requestAnimationFrame(() => {
            itemContent.classList.add(clsActiveExpand);
            itemContent.style.maxHeight = `${itemContent.scrollHeight + heightScreen}px`;
            itemHeading.classList.add(clsActiveClick);
          });
        }
      });

      appendContentToTableCells(module, item);
    };

    const appendContentToTableCells = (module, item) => {
      const groupContent = item.querySelector(clsGroupContent);
      const groupHeading = item.previousElementSibling;
      const tableTitle = module.querySelector('.wp-block-statik-tab--selected .gg-competitive-comparison__table-title table tbody tr');
      const titles = Array.from(tableTitle.children).map(td => td.textContent.trim());
      const rows = groupContent.querySelectorAll('table tbody tr');

      if (rows.length === 0 || groupHeading.querySelectorAll('td').length === 0) return;

      const existingParagraphs = groupContent.querySelectorAll('p');
      existingParagraphs.forEach(p => p.remove());

      rows.forEach((row) => {
        const cells = row.querySelectorAll('td');
        cells.forEach((cell, cellIndex) => {
          if (cellIndex > 0) {
            const titleText = titles[cellIndex] || "N/A";
            const p = document.createElement('p');
            p.textContent = titleText.trim();
            p.classList.add(`title-${cellIndex + 1}`);
            cell.insertBefore(p, cell.firstChild);
          }
        });
      });
    };

    module.querySelectorAll('.wp-block-statik-tabs__nav-item').forEach(item => {
      item.setAttribute('data-content', item.textContent.trim());
    });

    Array.from(swiperSlides).forEach((slide) => {
      slide.querySelectorAll(clsBlockAccordionCompetitive).forEach((item, index) => {
        item.setAttribute(dataIndex, index);
      });
    });

    accordions.forEach((accordion) => {
      const item = accordion.closest(clsBlockAccordionCompetitive);
      accordion.querySelector('td').addEventListener('click', () => toggleAccordion(accordion, item));
    });

    const tabButtons = module.querySelectorAll('.wp-block-statik-tabs__nav-item');
    tabButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        const selectedTab = module.querySelector('.wp-block-statik-tab--selected');
        selectedTab.querySelectorAll('.gg-block-accordion-competitive').forEach((item) => {
          appendContentToTableCells(module, item);
        });
        module.querySelectorAll(`.gg-block-accordion-competitive[data-index="${index - 1}"]`).forEach((item) => {
          console.log(item);
          const itemContent = item.querySelector(clsGroupContent);
          const itemHeading = item.querySelector(clsHeadingFirstChild);
          itemContent.classList.remove(clsActiveExpand);
          itemContent.style.maxHeight = null;
          itemHeading.classList.remove(clsActiveClick);
        })
      });
    });
  });
};

export default accordionCompetitive;
